import axios from '../axios'
import { REPORTROUTES } from 'src/router/Api'

export const getListReport = async (params) => {
	return await axios.get(REPORTROUTES.name, {
		params,
	})
}

export const getReportStats = async () => {
	return await axios.get(REPORTROUTES.stats)
}

export const updateReportStatus = async (id: string, status: string) => {
	return await axios.patch(REPORTROUTES.status(id), { status })
}

export const updateReportNote = async (
	id: string,
	payload: { note: string },
) => {
	return await axios.patch(REPORTROUTES.note(id), payload)
}

export const replyReportEmail = async (
	id: string,
	payload: { subject: string; body: string },
) => {
	return await axios.post(REPORTROUTES.replyEmail(id), payload)
}

export const blockReportTarget = async (
	id: string,
	payload: {
		reason: string
		type?: string
		target_type?: 'target' | 'reporter'
	},
) => {
	return await axios.post(REPORTROUTES.blockTarget(id), payload)
}

export const deleteReportContent = async (id: string) => {
	return await axios.post(REPORTROUTES.deleteContent(id))
}

export const rejectReport = async (id: string) => {
	return await axios.post(REPORTROUTES.reject(id))
}
